<template>
  <div class="flex justify-end items-center text-grey-academy-800">
    <span class="capitalize">{{ $t('languageSwitcher.label') }}</span>
    <custom-select-language class="pl-2 w-auto" :options="locales" />
  </div>
</template>

<script>
import supportedLocales from '@/util/i18n/supported-locales';
import CustomSelectLanguage from '@/components/CustomSelectLanguage.vue';

export default {
  data() {
    return {
      locales: supportedLocales.getSupportedLocales(),
    };
  },

  components: {
    CustomSelectLanguage,
  },

  computed: {
    selected() {
      let selectedLocale = '';
      this.locales.forEach((locale) => {
        if (locale.code === this.$i18n.locale) {
          selectedLocale = locale;
        }
      });
      return selectedLocale;
    },
  },

};
</script>

<style lang="scss" scoped>

  #selectLanguage {
    appearance: none;
    padding-left: 2px;
    background-color: #402516;
    color: #D9C0A3;
  }

</style>
